import { gql } from '@apollo/client';

export const activateUser = gql`
  mutation activateBusinessUser($userId: String!) {
    core {
      activateUser(userId: $userId) {
        id
        status
      }
    }
  }
`;
export const deactivateUser = gql`
  mutation deactivateBusinessUser($userId: String!) {
    core {
      deactivateUser(userId: $userId) {
        id
        status
      }
    }
  }
`;

export const activateUserAssignedLines = gql`
  mutation activateAssignedLines(
    $activateUserAssignedLinesInput: ActivateUserAssignedLinesInput!
  ) {
    salesforce {
      activateUserAssignedLines(
        activateUserAssignedLinesInput: $activateUserAssignedLinesInput
      )
    }
  }
`;

export const deactivateUserAssignedLines = gql`
  mutation deactivateAssignedLines(
    $deactivateUserAssignedLinesInput: DeactivateUserAssignedLinesInput!
  ) {
    salesforce {
      deactivateUserAssignedLines(
        deactivateUserAssignedLinesInput: $deactivateUserAssignedLinesInput
      )
    }
  }
`;

export const activateAssignedBPPlan = gql`
  mutation activateAssignedBPPlan(
    $activateUserAssignedBusinessPartnerPlansInput: ActivateUserAssignedBPPlansInput!
  ) {
    salesforce {
      activateUserAssignedBPPlans(
        activateUserAssignedBusinessPartnerPlansInput: $activateUserAssignedBusinessPartnerPlansInput
      )
    }
  }
`;

export const deactivateAssignedBPPlan = gql`
  mutation deactivateAssignedBPPlan(
    $deactivateUserAssignedBusinessPartnerPlansInput: DeactivateUserAssignedBPPlansInput!
  ) {
    salesforce {
      deactivateUserAssignedBPPlans(
        deactivateUserAssignedBusinessPartnerPlansInput: $deactivateUserAssignedBusinessPartnerPlansInput
      )
    }
  }
`;
